// extracted by mini-css-extract-plugin
export default {"header":"header__3_maL"};